import React from "react";
import PrimaryButton from "../../common/PrimaryButton/PrimaryButton";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";

interface DeleteServiceTypeDialogInterface {
    open: boolean;
    onClose: () => void;
    posNumber: string;
    onDeletePos: () => void;
    classes: any;
}

const DeletePosDialog = (props: DeleteServiceTypeDialogInterface) => {
    const {
        open,
        onClose,
        posNumber,
        onDeletePos,
        classes,
    } = props;

    const getAddUpdateDialogTitleContent = () => {
        return (
            <span className={classes.dialogTitleStyle}>
                {`Delete POS: `}
                <strong>{posNumber || ""}</strong>
            </span>
        );
    };

    const getAddUpdateDialogDetailsContent = () => {
        return (
            <span className={classes.dialogDetailsStyle}>
                This action is <strong>permanent</strong> and cannot be undone.
                <br />
                <span className={classes.dialogSubDetailsStyle}>
                    Note: A POS can only be deleted if there are{" "}
                    <strong>no service types and zones are associated</strong> with it.
                </span>
            </span>
        );
    };

    const getAddUpdateDialogActions = () => {
        return (
            <>
                <PrimaryButton
                    buttonLabel="CANCEL"
                    buttonVariant="outlined"
                    className={classes.buttonStyles}
                    onClick={onClose}
                />
                <PrimaryButton
                    buttonLabel="PROCEED"
                    buttonVariant="contained"
                    className={classes.deleteButtonStyles}
                    onClick={onDeletePos}
                />
            </>
        );
    };

    return (
        <Dialog classes={{ paperWidthSm: classes.dialogRoot }} onClose={onClose} open={open}        >
            <DialogTitle>{getAddUpdateDialogTitleContent()}</DialogTitle>
            <DialogContent>{getAddUpdateDialogDetailsContent()}</DialogContent>
            <DialogActions className="do-not-print">
                {getAddUpdateDialogActions()}
            </DialogActions>
        </Dialog>
    );
};

export default React.memo(DeletePosDialog);
